import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import InvoiceForm from '../../../components/InvoiceForm';

const CreateInvoice = () => {
  const context = useOutletContext();
  const [showInvoiceForm, setShowInvoiceForm] = useState(true);

  useEffect(() => {
    context(["Payments & Invoice", "Create Invoice"]);
  }, [context]);

  const handleClose = () => {
    setShowInvoiceForm(false);
    setTimeout(() => setShowInvoiceForm(true), 100);
  };

  return (
    <div className="p-5 shadow-md bg-white">
      <div className="flex flex-row justify-between gap-2 mb-4">
        <h3
          className="col-span-3 w-full text-lg uppercase tracking-wider font-bold"
          style={{ color: "#2EBAA3" }}
        >
          Create Invoice
        </h3>
      </div>
      
      {showInvoiceForm && (
        <InvoiceForm
          isOpen={true}
          onClose={handleClose}
          selectedPlan={null}
          userId={null}
          editInvoiceData={null}
          isEditMode={false}
          isPageMode={true}
        />
      )}
    </div>
  );
};

export default CreateInvoice;
